import { Activity, BodyProps } from "@ofqual/portal-activity-feed";

export enum DialogType {
  ActivityAction,
  AddNote,
  AddInternalMessage
}

export interface EntityDialog {
  dialogType: DialogType;
  focussedActivity?: Activity;
}

export type ActivityDocument = {
  blobId: string;
  fileName: string;
  contentType: string;
};

export type CaseAttachmentActivityBody = {
  responseType: number;
  message: string;
  subject: string;
  documents: ActivityDocument[];
};


export type AttachmentActivityBody = {
  message: string;
  documents: ActivityDocument[];
};

export type AttachmentBodyProps = {
  bodyProps: BodyProps<AttachmentActivityBody>;
};

export type ClosedActivityBody = {
  sharedWithIfate?: boolean;
};

export type InternalMessage = {
  subject: string;
  message: string;
  upns: Array<string>;
  documents: ActivityDocument[];
};

export type PublicMessage = {
  subject: string;
  message: string;
  isOfqual: boolean;
  documents: ActivityDocument[];
};

export type RecordTransfer = {
  action: string;
  upn: string;
  name: boolean;
};